@if (initialized && dto) {
    <div class="te-blueprint-container">

        <!-- View Mode Switcher - SelectButton -->
        <div class="view-mode-switcher flex align-items-center justify-content-between gap-2 p-3 bg-white border-bottom-1 border-300 {{viewMode == ConfigViewModeEnum.NODE_VIEW ? '-mt-4' : 'mt-1'}}">
            <div class="flex align-items-center gap-2">
                <h4 class="m-0 text-xl font-medium">{{dto.name}}</h4>
                @if (viewMode === ConfigViewModeEnum.NODE_VIEW && displayMode) {
                    <span class="display-mode-badge text-xs font-semibold px-2 py-1 border-round"
                          [ngClass]="getDisplayModeColorClass()">
                        <i [class.fa-light]="true" [class]="getDisplayModeIcon()"></i>
                        <span class="ml-1">{{ getDisplayModeLabel() }}</span>
                    </span>
                }
            </div>
            <p-selectButton
                [options]="[
                    { label: 'Node View', value: ConfigViewModeEnum.NODE_VIEW, icon: 'fa-diagram-project fa-light' },
                    { label: 'Standard View', value: ConfigViewModeEnum.STANDARD, icon: 'fa-table-columns fa-light' }
                ]"
                [(ngModel)]="viewMode"
                (onChange)="onViewModeChange($event.value)"
                optionLabel="label"
                optionValue="value"
                [style]="{'min-width': '200px'}">
                <ng-template pTemplate="selectedItem" let-option>
                    <i [class]="option.icon"></i>
                    <span class="ml-2">{{ option.label }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-option>
                    <i [class]="option.icon"></i>
                    <span class="ml-2">{{ option.label }}</span>
                </ng-template>
            </p-selectButton>
        </div>

        @if (viewMode === ConfigViewModeEnum.NODE_VIEW) {
            <!-- Node View - Using the generic mvs-config-node-view component -->
            <mvs-config-node-view
                    (onDisplayModeChange)="handleDisplayModeChange($event)"
                    [config]="blueprintNodeViewConfig"
                    [rootEntityId]="objectIdentifier.objectId"
                    [rootEntityName]="dto.name"
                    [rootEntityIcon]="dto?.image"
                    (onNodeSelect)="handleNodeSelect($event)"
                    (onAddChild)="handleAddChild($event)"
                    (onNodeEdit)="handleNodeEdit($event)"
                    (onBusyChange)="handleNodeViewBusyChange($event)"
                    (onDataLoaded)="handleNodeViewDataLoaded()">
            </mvs-config-node-view>
        } @else {
            <!-- Standard View - Original side/full view -->
            @if (uiMode == 'side') {
                <te-blueprint-object-component-side
                        [objectIdentifier]="objectIdentifier"
                        [dto]="dto"
                        [uiMode]="uiMode"
                        (onNavigationItems)="handleNavigationItems($event)"
                ></te-blueprint-object-component-side>
            } @else {
                <te-blueprint-object-component-full
                        [objectIdentifier]="objectIdentifier"
                        [dto]="dto"
                        [uiMode]="uiMode"
                        (onNavigationItems)="handleNavigationItems($event)"
                        (onBreadcrumbItems)="handleBreadcrumbItems($event)"
                ></te-blueprint-object-component-full>
            }
        }

    </div>
}
